module.exports = __webpack_public_path__ + "static/media/زيارة المدن والتسوق.8401f266.jpg";